module.exports = __webpack_public_path__ + "static/media/gluko-sokolata-xalba-karamela.25b4bfed.jpg";